import React from "react";
import PaymentTerminal from "../../../../stories/_setting/PaymentTerminals/PaymentTerminal";
import FormStart from "../../../form/paymentterminal/FormStart";
import '../../../../css/overbox/PaymentTerminalInformation.css';

const NewObject = props => {
    const {handleIndex} = props;

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox start">
                    <FormStart object={new PaymentTerminal()} handleIndex={handleIndex} />
                </div>
            </div>
        </div>
    )
}

export default NewObject;
